<form [formGroup]="loginForm" class="w-100" (submit)="loginSubmit()">
  @if (loginFailedError$ | async; as errorMessage) {
  <atx-alert
    [severity]="severity.Error"
    [icon]="['fas', 'exclamation-triangle']"
  >
    {{ errorMessage }}
  </atx-alert>
  }
  <div class="form-group">
    <fa-icon [icon]="['fas', 'user']" class="input-icon"></fa-icon>
    <input
      type="text"
      class="form-control"
      id="username-input"
      formControlName="username"
      placeholder="Email address"
      i18n-placeholder="
        AuthPage|Username placeholder value@@loginPageUsernamePlaceholder"
    />
  </div>
  <div class="form-group">
    <fa-icon [icon]="['fas', 'lock']" class="input-icon"></fa-icon>
    <input
      #passwordInput
      [type]="(passwordVisible$ | async) ? 'text' : 'password'"
      class="form-control"
      id="password-input"
      formControlName="password"
      placeholder="Password"
      i18n-placeholder="
        AuthPage|Password placeholder value@@loginPagePasswordPlaceholder"
    />
    <fa-icon
      [icon]="['fas', 'eye']"
      class="input-icon eye"
      (click)="togglePasswordType()"
      [atxTooltip]="(passwordTooltip$ | async) || ''"
    >
    </fa-icon>
  </div>
  @if (needToAgreeToTerms) {
  <div
    class="form-group form-check terms-check"
    [class.checked]="termsChecked"
    (click)="toggleTerms()"
  >
    <input
      type="checkbox"
      class="form-check-input"
      id="terms-check-input"
      formControlName="terms"
    />
    <label
      class="form-check-label text-uppercase ml-2"
      i18n="AuthPage|Terms of service label value@@loginPageTermsOfServiceLabel"
    >
      I ACCEPT THE
      <strong (click)="$event.stopPropagation(); showTermsModal()"
        >TERMS OF SERVICE</strong
      >
    </label>
  </div>
  }

  <button
    type="submit"
    class="btn btn-primary w-100 d-flex align-items-center justify-content-center text-uppercase login-btn mt-4"
    [disabled]="loginForm.invalid"
    i18n="AuthPage|Login button value@@loginPageLoginButton"
  >
    <fa-icon
      [icon]="['far', 'right-to-bracket']"
      size="xs"
      class="mr-2"
    ></fa-icon>
    Sign In
  </button>

  <div class="d-flex flex-column align-items-center mt-3">
    <a
      [routerLink]="['../', 'forgot-password']"
      [queryParams]="queryParams"
      class="text-decoration-none text-uppercase d-flex align-items-center login-page-link"
      i18n="AuthPage|Forgot password link value@@loginPageForgotPasswordLink"
    >
      <fa-icon [icon]="['fas', 'lock']" size="xs" class="mr-2"></fa-icon>
      Forgot Password
    </a>

    <a
      class="text-decoration-none text-uppercase mt-3 d-flex align-items-center cursor-pointer login-page-link"
      i18n="AuthPage|Support modal link value@@loginPageSupportModalLink"
      (click)="openSupportModal()"
    >
      <fa-icon
        [icon]="['fas', 'circle-question']"
        size="xs"
        class="mr-2"
      ></fa-icon>
      Support
    </a>
  </div>
</form>
@if (message$ | async; as message) {
<div class="message-container p-3 d-flex mt-3 align-items-start">
  <fa-icon [icon]="['fas', 'triangle-exclamation']" size="xl"></fa-icon>
  <div class="message" [innerHTML]="message.message | safeHtml"></div>
</div>
}
